"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateInsurance = void 0;
const enums_1 = require("../../enums");
const validateInsurance = (insurance) => {
    var _a;
    let missing = [];
    if (!insurance)
        missing.push(enums_1.OrderValidation.MissingInsurance);
    if (!(insurance === null || insurance === void 0 ? void 0 : insurance.reference))
        missing.push(enums_1.OrderValidation.MissingInsuranceReference);
    if (!((_a = insurance === null || insurance === void 0 ? void 0 : insurance.reference) === null || _a === void 0 ? void 0 : _a.santanderId))
        missing.push(enums_1.OrderValidation.MissingInsuranceReferenceSantanderId);
    return Array.from(new Set(missing));
};
exports.validateInsurance = validateInsurance;
//# sourceMappingURL=insurance.js.map